// Toggle dropdown visibility and icon change
function toggleDropdown(el, childDropdown, iconElement, iconOriginal, iconDropdown) {
  // Toggle icons if applicable
  if (iconElement && iconOriginal && iconDropdown) {
    if (iconElement.classList.contains(iconOriginal)) {
      iconElement.classList.remove(iconOriginal);
      iconElement.classList.add(iconDropdown);
    } else if (iconElement.classList.contains(iconDropdown)) {
      iconElement.classList.remove(iconDropdown);
      iconElement.classList.add(iconOriginal);
    }
  } else if (iconOriginal && iconDropdown) {
    if (el.classList.contains(iconOriginal)) {
      el.classList.remove(iconOriginal);
      el.classList.add(iconDropdown);
    } else if (el.classList.contains(iconDropdown)) {
      el.classList.remove(iconDropdown);
      el.classList.add(iconOriginal);
    }
  }

  // Close other dropdowns
  document.querySelectorAll('[data-dropdown-child]').forEach(childEl => {
    if (!childEl.classList.contains('u-hidden') && childEl !== childDropdown) {
      childEl.classList.add('u-hidden');
    }
  });

  // Toggle current dropdown
  childDropdown.classList.toggle('u-hidden');
}

function init() {
  const closeAllDropdowns = () => {
    document.querySelectorAll('[data-dropdown-child]').forEach(childEl => {
      if (!childEl.classList.contains('u-hidden')) {
        childEl.classList.add('u-hidden');
      }
    });
  };

  document.querySelectorAll('[data-dropdown]').forEach(el => {
    const id = el.getAttribute('data-dropdown-id');
    const iconOriginal = el.getAttribute('data-icon-original');
    const iconDropdown = el.getAttribute('data-icon-dropdown');
    const iconElement = document.querySelector(`[data-icon-${id}]`);
    const childDropdown = document.querySelector(`[data-dropdown-child-${id}]`);

    if (id && childDropdown) {
      // Handle click to toggle dropdown
      el.addEventListener('click', event => {
        event.preventDefault();
        toggleDropdown(el, childDropdown, iconElement, iconOriginal, iconDropdown);
      });

      // Handle keydown to toggle dropdown when 'Enter' is pressed
      el.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault(); // Prevent default behavior (like form submission)
          toggleDropdown(el, childDropdown, iconElement, iconOriginal, iconDropdown);
        }
      });

      // Handle blur (close dropdown when focus leaves, but not if focus moves into submenu)
      el.addEventListener('blur', event => {
        setTimeout(() => { // Delay to allow focus to shift before closing
          if (
            !el.contains(document.activeElement) &&
            !childDropdown.contains(document.activeElement)
          ) {
            closeAllDropdowns();
          }
        }, 0);
      });
    }
  });

  // Close dropdowns when clicking outside, except on parent link
  document.addEventListener('click', event => {
    const isParentLink = event.target.closest('[data-dropdown]');
    const isChildDropdown = event.target.closest('[data-dropdown-child]');
    if (!isParentLink && !isChildDropdown) {
      closeAllDropdowns();
    }
  });

  // Close dropdowns when tabbing outside
  document.addEventListener('keydown', event => {
    if (event.key === 'Tab') {
      setTimeout(() => {
        const focusedElement = document.activeElement;
        const isInsideDropdown = focusedElement && (focusedElement.closest('[data-dropdown]') || focusedElement.closest('[data-dropdown-child]'));

        if (!isInsideDropdown) {
          closeAllDropdowns();
        }
      }, 0); // Allow time for focus to change
    }
  });
}

export default { init };
